import { render } from "./Header.vue?vue&type=template&id=2f7a8a42&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=2f7a8a42&lang=css"
import "./Header.vue?vue&type=style&index=1&id=2f7a8a42&scoped=true&lang=css"
/* custom blocks */
import block0 from "./Header.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7a8a42"]])

export default __exports__